import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['original', 'result', 'form', 'submit', 'toggle', 'status', 'translated', 'failure', 'submitLabel', 'toggleLabel']
  static values = { original: String, translated: String, failed: String, retry: String }

  start(event) {
    if (event?.target && event.target !== this.formTarget) return
    this.resultTarget.replaceChildren()
    this.element.setAttribute('aria-busy', 'true')
    this.statusTarget.textContent = ''
    this.statusTarget.hidden = true
    this.submitTarget.disabled = true
  }

  finish(event) {
    if (event.target && event.target !== this.formTarget) return
    this.element.removeAttribute('aria-busy')
    this.submitTarget.disabled = false
    if (!event.detail.success) {
      this.statusTarget.textContent = this.failedValue
      this.statusTarget.hidden = false
      this.submitLabelTarget.textContent = this.retryValue
    }
  }

  translatedTargetConnected() {
    this.originalTarget.hidden = true
    this.formTarget.hidden = true
    this.resultTarget.hidden = false
    this.toggleTarget.hidden = false
    this.toggleLabelTarget.textContent = this.originalValue
    this.statusTarget.textContent = ''
    this.statusTarget.hidden = true
    this.toggleTarget.focus({ preventScroll: true })
  }

  failureTargetConnected() {
    this.submitLabelTarget.textContent = this.retryValue
    this.submitTarget.focus({ preventScroll: true })
  }

  toggle() {
    const showOriginal = this.originalTarget.hidden
    this.originalTarget.hidden = !showOriginal
    this.resultTarget.hidden = showOriginal
    this.toggleLabelTarget.textContent = showOriginal ? this.translatedValue : this.originalValue
  }

  reset() {
    this.originalTarget.hidden = false
    this.resultTarget.replaceChildren()
    this.resultTarget.hidden = false
    this.formTarget.hidden = false
    this.toggleTarget.hidden = true
    this.statusTarget.textContent = ''
    this.statusTarget.hidden = true
    this.element.removeAttribute('aria-busy')
    this.submitTarget.disabled = false
  }
}
